<template>
  <!-- postech form -->
   <div v-if="loading">
    ...loading postech form...
   </div>
  <div v-else class="container">
    <div class="debug">
      <p><b>Postech-form.vue</b></p>
      <p>props.postechId = {{ props.postechId }}</p>
      <p>postech = {{ postech }}</p>
      </div>

    <MyForm :title="'Postech Form'">
      <template v-slot:fields>
   <!--     <FormInput
          v-model="postech.id"
          :readonly="true"
          :disabled="true"
          :name="'postech id:'"
        ></FormInput>
        <FormInput
          v-model="postech.projectId"
          :readonly="true"
          :disabled="true"
          :name="'project id:'"
        ></FormInput> -->
        <FormInput v-if="postech!=null" v-model="postech.pilesSupporting" :name="'piles supporting:'"></FormInput>
        <CustomerListbox v-model:customer="postech.installer" :key="customerKey"></CustomerListbox>
       
        <RadioGroup :options="radioOptions" v-model:selected="postech.pileLoads"></RadioGroup>

     
        <Suspense>
          <template #default>
            <Postech-piles-table v-model:piles="postech.piles"></Postech-piles-table>
          </template>
          <template #fallback> assigning piles.... </template>
        </Suspense>
      </template>

      <template v-slot:buttons>
        <div class="form-btns">
          <FormBtn :name="'Create Closeout'" @clicked="createCloseout"></FormBtn>
          <FormBtn :name="'Save Changes'" @clicked="submitForm"></FormBtn>
          <FormBtn :name="'Revert'" @clicked="revertForm"></FormBtn>
          <FormBtn :name="'Delete Postech'" @clicked="deletePostech" :class="'red'"></FormBtn>
        </div>
      </template>
    </MyForm> 

    <!--Prompt :name="'postech'" @confirmed="deletePostech" @cancelled="cancelDelete"></Prompt-->
    <div class="debug">
      <p>Within Postech-form.vue:</p>
      <p>reactive postech:</p>
      <p v-for="(value, key) in postech" :key="key">{{ key }}: {{ value }}</p>
    </div>
  </div>
  <!-- end of postech view -->
</template>

<script setup lang="ts">
import { onBeforeMount, ref, watch } from 'vue'
import { MyForm, FormInput, FormBtn, RadioGroup, Prompt } from '@/components'
import PostechPilesTable from './Postech-piles-table.vue'
import CustomerListbox from '@/components/Customer-listbox.vue';
import { usePostechStore, usePromptStore, usePileStore } from '@/stores'
//import Prompt from '@/components/Prompt.vue'
import router from '@/router'
import type { Postech, PostechPile, PileType } from '@/types/types'
//import { storeToRefs } from 'pinia';


//const prompt = usePromptStore()
const postechStore = usePostechStore()
const props = defineProps<{
  postechId: number
}>()
const loading = postechStore.loading;

function cancelDelete(){
  console.log("postech delete cancelled from prompt...");
}
//const loading = ref(true);
const postech = ref<Postech>(null)
//async component within Suspense:
postech.value = await postechStore.getById(props.postechId);
console.log("..postech-form postech.value from await: " + JSON.stringify(postech.value));
/*
onBeforeMount(async ()=>{
  console.log("postechId = " + props.postechId)
  postech.value = await postechStore.getById(props.postechId)
  console.log("postech = " + JSON.stringify(postech.value));
  loading.value = false;
})*/


const radioOptions = ['Loads Calculated', 'Loads Provided by Others']
//const pileOptionscachecache = ref<Array<PileType>>([]) //projects.fetchPileOptions);
//const pileStore = usePileStore();
//const { allPiles } = storeToRefs(pileStore);
//await fetchPileOptions()

const customerKey = ref(1);
watch(postech,()=>{
  customerKey.value+=1;
})

async function confirmDelete() {
  console.log('postech form confirm delete()...')
  prompt.promptUser({
    header: 'Delete Postech?',
    body: 'This will permanently delete this postech component from the project, continue?'
  })
}

const pilesHeader = ['pileType', 'pileCount', 'torqueMin', 'torqueMax']

/*async function fetchPileOptions() {
  console.log('Postech-form.fetchPileOptions()...')
  pileOptions.value = await postechStore.getAllPileTypes()
}*/

/**
 * Submit postech form via pinia store
 */
async function submitForm() {
  console.log('Postech-form.submitForm()..')
  postech.value.installer_id = postech.value.installer.id;
  await postechStore.updatePostech(postech.value);
  
}

/**
 * TODO this works on a single postech object, search that up from Contrller
 */
async function revertForm() {
  console.log('Postech-form.revertForm()...')
  // await fetchPostech();
  postech.value = await postechStore.getById(props.postechId)
}

async function deletePostech() {
 // prompt.close()
  console.log('Postech-form.deletePostech()...')

  const projId = postech.value?.projectId
  await postechStore.deletePostech(postech.value.id)
  router.push({ name: 'project_postechs', params: { projectId: projId } })
}

const writeableFields = [
  { id: 'mPileId', name: 'Pile Group Id', comp: 'pileId', disabled: true },
  { id: 'mPileType', name: 'Pile Type', comp: 'pileType' },
  { id: 'mTorqueMin', name: 'Min Torque', comp: 'torqueMin' },
  { id: 'mTorqueMax', name: 'Max Torque', comp: 'torqueMax' },
  { id: 'mPileCount', name: 'Pile Count', comp: 'pileCount' }
]

//TODO emit this to accordion parent and have one modal instance for the group
/*function pileGroupClicked(item: PostechPile) {
  console.log('pileGroupClicked...doing nothing')
  console.log('item = ' + JSON.stringify(item))
  //bind item to mPileGroup
  // state.modal_editing = true;
  //mPileGroup.value = item;
  //mPileGroup.value = Object.assign(item, {});
  //openModal();
}*/

//TODO create google doc
async function createCloseout() {
  console.log('postech form.createCloseout()...')
  await postechStore.createCloseout(postech.value)
}
</script>
